import { Button, ButtonProps } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import confirmModal from '@/components/_common/ConfirmBackModal';

interface Props extends ButtonProps {
  path: string;
  disabled?: boolean;
}

const ButtonBack: React.FC<Props> = ({ path, disabled = true, ...props }) => {
  const history = useHistory();
  return (
    <Button
      block
      type="ghost"
      onClick={
        disabled
          ? () => history.push(path)
          : () => confirmModal(() => history.push(path))
      }
      {...props}
    >
      Voltar
    </Button>
  );
};

export default ButtonBack;
